// This is the root reducer of the feature. It is used for:
//   1. Load reducers from each action in the feature and process them one by one.
//      Note that this part of code is mainly maintained by Rekit, you usually don't need to edit them.
//   2. Write cross-topic reducers. If a reducer is not bound to some specific action.
//      Then it could be written here.
// Learn more from the introduction of this approach:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da.

import initialState from './initialState';
import { reducer as fetchQuesCreateChapterReducer } from './fetchQuesCreateChapter';
import { reducer as setFontSizeReducer } from './setFontSize';
import { reducer as fetchSubmitQuesReducer } from './fetchSubmitQues';
import { reducer as fetchGetQuesChapterReducer } from './fetchGetQuesChapter';
import { reducer as updateCheckParsIndexReducer } from './updateCheckParsIndex';
import { reducer as updateCheckAllParsReducer } from './updateCheckAllPars';
import { reducer as updateCurQuesIndexReducer } from './updateCurQuesIndex';
import { reducer as fetchSubmitPraReducer } from './fetchSubmitPra';
import { reducer as fetchQuesContinueChapterReducer } from './fetchQuesContinueChapter';
import { reducer as fetchQuesExamReducer } from './fetchQuesExam';
import { reducer as fetchGetExamQuesListReducer } from './fetchGetExamQuesList';
import { reducer as fetchGetExamDetailReducer } from './fetchGetExamDetail';
import { reducer as fetchGetExamPageResultReducer } from './fetchGetExamPageResult';
import { reducer as updateQuesTypeIndexReducer } from './updateQuesTypeIndex';

const reducers = [
  fetchQuesCreateChapterReducer,
  setFontSizeReducer,
  fetchSubmitQuesReducer,
  fetchGetQuesChapterReducer,
  updateCheckParsIndexReducer,
  updateCheckAllParsReducer,
  updateCurQuesIndexReducer,
  fetchSubmitPraReducer,
  fetchQuesContinueChapterReducer,
  fetchQuesExamReducer,
  fetchGetExamQuesListReducer,
  fetchGetExamDetailReducer,
  fetchGetExamPageResultReducer,
  updateQuesTypeIndexReducer,
];

export default function reducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    // Handle cross-topic actions here
    default:
      newState = state;
      break;
  }
  return reducers.reduce((s, r) => r(s, action), newState);
}



// WEBPACK FOOTER //
// ./src/features/ques-store/redux/reducer.js